<script setup lang="ts">
import type { GradeCode } from '~/models/Grade'
import { useI18n } from 'vue-i18n'
import Button from '~/components/ui/Button.vue'

const { options } = defineProps<{ options: GradeCode[] }>()
const selectedGrades = defineModel<GradeCode[]>()

const { t } = useI18n()
</script>

<template>
  <aside class="grid-in-filters">
    <form class="flex flex-col gap-2 rounded-xl bg-white p-3">
      <Button
        type="label"
        :variant="Number(selectedGrades?.length) > 1 ? 'solid' : 'ghost'"
        :shade="Number(selectedGrades?.length) > 1 ? 'light' : 'dark'"
        color="blue"
        class="focus-within:ring"
      >
        <input
          v-model="selectedGrades"
          :value="options"
          type="radio"
          class="ring-blue-40 checked:bg-blue-40 size-2 appearance-none rounded-full bg-white ring ring-offset-2"
        >
        <span class="ml-2">{{ t('search.filters.allGrades') }}</span>
      </Button>
      <Button
        v-for="grade in options"
        :key="grade"
        :variant="selectedGrades?.every(g => g === grade) ? 'solid' : 'ghost'"
        :shade="selectedGrades?.every(g => g === grade) ? 'light' : 'dark'"
        type="label"
        color="blue"
        class="focus-within:ring"
      >
        <input
          v-model="selectedGrades"
          :value="[grade]"
          type="radio"
          class="ring-blue-40 checked:bg-blue-40 size-2 appearance-none rounded-full bg-white ring ring-offset-2"
        >
        <span class="ml-2">{{ t(`metadata.grades.${grade}`) }}</span>
      </Button>
    </form>
  </aside>
</template>
